import { render, staticRenderFns } from "./Profile copy 2.vue?vue&type=template&id=6a593e76"
import script from "./Profile copy 2.vue?vue&type=script&lang=js"
export * from "./Profile copy 2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports